import gql from 'graphql-tag';

export default gql`
  query flightSearchCriteria {
    flightSearchCriteria {
      tripType
      origin
      destination
      departDate
      returnDate
      adultsCount
      lapInfantDobs
      childrenDobs
      lapInfantCount
      childrenCount
      infantCount
    }
    order {
      items {
        id
        ... on FlightOrderItem {
          flight {
            id
            departingTime
          }
        }
      }
    }
  }
`;
